import React, { useState, useEffect } from "react";
import "../../Styles/navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { ADMIN_EMAIL, auth } from "../../firebase";


const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!auth) {
      setUser(null);
      return undefined;
    }

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  const isAdmin = Boolean(user && ADMIN_EMAIL && user.email?.trim().toLowerCase() === ADMIN_EMAIL);

  const handleLogout = async () => {
    if (!auth) {
      return;
    }

    await signOut(auth);
    setMenuOpen(false);
    navigate("/");
  };

  return (
    <nav className="banner">
      <div className="nav-left">
        <img src="/Images/White_Logo.png" alt="Logo" className="logo" />
        <h2 className="wording">TLynn</h2>
      </div>

      {/* Desktop Menu */}
      {!isMobile && (
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/Events">Events</Link></li>
          <li><Link to="/About">About</Link></li>
          <li><Link to="/Social">Social Media</Link></li>
          <li><Link to="/Booking">Book/Contact</Link></li>
          {isAdmin ? (
            <li className="admin-nav-item">
              <span className="admin-label">Admin</span>
              <button type="button" className="logout-button" onClick={handleLogout}>Logout</button>
            </li>
          ) : null}
        </ul>
      )}

      {/* Hamburger for Mobile */}
      {isMobile && (
        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={menuOpen ? "bar open" : "bar"}></span>
          <span className={menuOpen ? "bar open" : "bar"}></span>
          <span className={menuOpen ? "bar open" : "bar"}></span>
        </div>
      )}

      {/* Mobile Dropdown Menu */}
      {isMobile && menuOpen && (
        <ul className="mobile-menu">
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/Events" onClick={() => setMenuOpen(false)}>Events</Link></li>
          <li><Link to="/About" onClick={() => setMenuOpen(false)}>About</Link></li>
          <li><Link to="/Social" onClick={() => setMenuOpen(false)}>Social Media</Link></li>
          <li><Link to="/Booking" onClick={() => setMenuOpen(false)}>Book/Contact</Link></li>
          {isAdmin ? (
            <li className="admin-nav-item">
              <span className="admin-label">Admin</span>
              <button type="button" className="logout-button" onClick={handleLogout}>Logout</button>
            </li>
          ) : null}
          <li>
            <button className="close-menu" onClick={() => setMenuOpen(false)}>
              Close
            </button>
          </li>
        </ul>
      )}
    </nav>
  );
};

const Homepage = () => {
  return (
    <div>
      <Navbar />
      {/* ...rest of your homepage content */}
    </div>
  );
};

export default Homepage;
